export default __webpack_public_path__ + "file/Fiche-FR-Produit-Puroak-Granulés.asset.a86f5a31.pdf";